import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getGames = () => client.get("/games").then((r) => r.data);
export const getLatest = (game) => client.get(`/draws/${game}/latest`).then((r) => r.data);
export const getAnalytics = (game, window) =>
  client.get(`/analytics/${game}`, { params: { window } }).then((r) => r.data);
export const getHistory = (game, params) =>
  client.get(`/draws/${game}`, { params }).then((r) => r.data);
export const generatePicks = (game, window) =>
  client.post(`/ai/picks/${game}`, null, { params: { window } }).then((r) => r.data);
export const getSavedPicks = (game) =>
  client.get("/saved-picks", { params: game ? { game } : {} }).then((r) => r.data);
export const savePick = (payload) => client.post("/saved-picks", payload).then((r) => r.data);
export const deletePick = (id) => client.delete(`/saved-picks/${id}`).then((r) => r.data);
export const getBacktest = (game, strategy, sample = 150) =>
  client.get(`/backtest/${game}`, { params: { strategy, sample } }).then((r) => r.data);
export const getBacktestCompare = (game, sample = 150) =>
  client.get(`/backtest/${game}/compare`, { params: { sample } }).then((r) => r.data);
export const subscribe = (payload) => client.post("/subscribe", payload).then((r) => r.data);
export const getIngestStatus = () => client.get("/ingest/status").then((r) => r.data);

export const GAME_THEME = {
  mega_millions: {
    name: "Mega Millions",
    color: "#FFD700",
    ring: "rgba(255,215,0,0.5)",
    text: "text-[#FFD700]",
    days: "Tue & Fri",
  },
  powerball: {
    name: "Powerball",
    color: "#00F0FF",
    ring: "rgba(0,240,255,0.5)",
    text: "text-[#00F0FF]",
    days: "Mon, Wed & Sat",
  },
};
